<div class="clients-section">
  <!-- Main headline section -->
  <div class="clients-headline"> 
    <h2 class="headline-text fs-25">Our <span class="gradient-text">Partners</span></h2>
    <h2 class="headline-text mt-3">We only work with established and trusted partners who have undergone a rigorous due
      diligence process.</h2>
  </div>

  <!-- Client Logos Carousel -->
  <div class="client-logos-carousel">
    <div class="carousel-container">
      <div class="logos-wrapper">
        <div class="logos-container">
          <!-- First set of logos -->
          <div class="logo-item" *ngFor="let logo of logos; let i = index">
            <img [src]="logo.src" [alt]="logo.alt" (error)="onImageError($event)">
            <div class="logo-fallback">{{logo.alt}}</div>
          </div>
          <!-- Duplicate set of logos for continuous scrolling -->
          <div class="logo-item" *ngFor="let logo of logos; let i = index">
            <img [src]="logo.src" [alt]="logo.alt" (error)="onImageError($event)">
            <div class="logo-fallback">{{logo.alt}}</div>
          </div>
          <!-- Third set for extra smooth scrolling -->
          <div class="logo-item" *ngFor="let logo of logos; let i = index">
            <img [src]="logo.src" [alt]="logo.alt" (error)="onImageError($event)">
            <div class="logo-fallback">{{logo.alt}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Content section below logos -->
  <div class="clients-content">
    <div class="content-card">
      <div class="feature-points">
        <div class="feature-item">
          <div class="feature-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L15.09 8.26L22 9L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9L8.91 8.26L12 2Z" fill="#0075C9"/>
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="feature-text">One of the key criteria in being able to partner with HPS Life is our partners demonstrable experience and expertise in working with customers who have a history of complex pre-existing conditions.</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L15.09 8.26L22 9L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9L8.91 8.26L12 2Z" fill="#0075C9"/>
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="feature-text">It may be a long time in the past, such as alcohol, drug use or a chronic condition such as diabetes. Our partners are there to guide the customer through the process and advise based on circumstances and need.</span>
        </div>
      </div>
    </div>
  </div>
</div>